module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/solo-180509cfadb6d5e09331a7fd555c6b6d.png";